import { Plan } from "@/types";
import { getKFormat } from "@/utils";
import { Currency, formatPriceToBeInCurrency } from "@zapier/currency";
import { Text } from "@zapier/design-system";

type PlanUnavailableDescriptionProps = {
  isTaskTooHigh: boolean;
  minPlan: Plan;
  maxPlan: Plan;
  currency: Currency;
  isCustomLimit?: boolean;
  isAnnual: boolean;
};

export const PlanUnavailableDescription = ({
  isTaskTooHigh,
  minPlan,
  maxPlan,
  currency,
  isCustomLimit,
  isAnnual,
}: PlanUnavailableDescriptionProps) => {
  const getText = () => {
    const getFormattedCost = (amount: number) => {
      const formattedPrice = formatPriceToBeInCurrency(
        isAnnual ? amount / 12 : amount,
        currency
      );
      const formattedCurrency =
        currency.symbol === "$" ? ` ${currency.name}` : "";

      return `${formattedPrice}${formattedCurrency}/mo`;
    };

    if (isCustomLimit) {
      return "Contact sales for custom limits";
    } else if (isTaskTooHigh) {
      return `
          Available up to ${getKFormat(Number(maxPlan.tasks))} tasks for
          ${getFormattedCost(maxPlan.amount)}
        `;
    }

    return `
        Starts at ${getKFormat(Number(minPlan.tasks))} tasks for
        ${getFormattedCost(minPlan.amount)}
      `;
  };

  return (
    <Text tag="p" type="smallPrint1" margin="25px 0 0 0" color="neutral600">
      <span>{getText()}</span>
    </Text>
  );
};
